(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-pickie-r3]';

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : (fallback || 0);
  }

  function money(root, cents) {
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = document.documentElement.lang || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(toNumber(cents) / 100);
    } catch (error) {
      return '$' + (toNumber(cents) / 100).toFixed(2);
    }
  }

  function activePack(root) {
    return root.querySelector('[data-pickie-r3-pack].is-active') ||
      root.querySelector('[data-pickie-r3-pack]');
  }

  function activePurchase(root) {
    return root.querySelector('[data-pickie-r3-purchase].is-active') ||
      root.querySelector('[data-pickie-r3-purchase="onetime"]');
  }

  function activate(root, selector, selected) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), function (card) {
      var isSelected = card === selected;
      var input = card.querySelector('input[type="radio"]');

      card.classList.toggle('is-active', isSelected);
      if (input) input.checked = isSelected;
    });
  }

  /* The Apstle subscription widget injects its own radios named
     `selling_plan` into this form — both with `value=""`, the real plan id
     parked in `data-appstle-real-value`, and its one-time option checked. Its
     UI is hidden on these PDPs, so those radios never reflect a real choice,
     and it re-injects them whenever the variant changes.

     They are disabled rather than removed: a disabled control is never
     submitted, so no native form post can send an empty plan, but Apstle's own
     script still finds the elements it expects instead of throwing. Removing
     ours and re-appending is still how our own value is set. */
  function neutraliseForeignPlanFields(form) {
    Array.prototype.forEach.call(form.querySelectorAll('[name="selling_plan"]'), function (input) {
      if (input.hasAttribute('data-pickie-r3-plan')) return;
      if (!input.disabled) input.disabled = true;
    });
  }

  function setSellingPlan(form, sellingPlanId) {
    Array.prototype.forEach.call(form.querySelectorAll('input[data-pickie-r3-plan]'), function (input) {
      input.remove();
    });

    neutraliseForeignPlanFields(form);

    if (!sellingPlanId) return;

    var planInput = document.createElement('input');
    planInput.type = 'hidden';
    planInput.name = 'selling_plan';
    planInput.value = sellingPlanId;
    planInput.setAttribute('data-pickie-r3-plan', '');
    form.appendChild(planInput);
  }

  function setVariant(form, variantId) {
    var variantField = form.querySelector('[name="id"]');
    if (!variantField || !variantId) return;

    if (String(variantField.value) !== String(variantId)) {
      variantField.value = variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* The legacy pickie-buybox-v4 mirror was removed from product-form.liquid.
     This box now writes the form directly, so there is nothing to sync to. */

  function quantity(form) {
    var input = form.querySelector('input[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function moveQuantityIntoBuybox(root, form) {
    var slot = root.querySelector('[data-pickie-r3-quantity-slot]');
    if (!slot || slot.children.length) return;

    var blocks = Array.prototype.slice.call(
      form.querySelectorAll('.product__form-block.pickie-quantity-block')
    );

    var quantityBlock = blocks.find(function (block) {
      return block.parentElement && block.parentElement.classList.contains('pickie-quantity-block');
    });

    if (!quantityBlock) quantityBlock = blocks[blocks.length - 1];
    if (!quantityBlock) return;

    var formerParent = quantityBlock.parentElement;
    /* The quantity heading now uses the same .pickie-step class as steps 1
       and 2, marked with data-pickie-qty-label. The old class name is kept in
       the lookup so a cached page still finds it. */
    var label = quantityBlock.querySelector('[data-pickie-qty-label]') ||
      quantityBlock.querySelector('.pickie-buybox-v4__label');
    if (label) label.textContent = '3. Choose quantity';

    quantityBlock.setAttribute('data-pickie-r3-quantity', '');
    slot.appendChild(quantityBlock);

    if (
      formerParent &&
      formerParent.classList.contains('pickie-quantity-block') &&
      formerParent.children.length === 0
    ) {
      formerParent.remove();
    }
  }

  /* Find the price element under the product title, and put it back if an app
     has taken it over.
     ------------------------------------------------------------------------
     Captured from the live storefront: Apstle rewrites this element, stamps it
     `data-appstle-price-modified="true"`, and in doing so REMOVES our
     `data-pickie-top-price` attribute and injects its own
     `.appstle-save-badge`. After that `querySelector('[data-pickie-top-price]')`
     finds nothing, so the price above the buy box silently stops tracking the
     pack and purchase type the customer has chosen — and repeated injections
     leave a row of struck prices and "SAVE $3.00" badges spilling sideways
     out of the price row.

     So the element is located by its stable wrapper instead, our attribute is
     restored, and anything an app has added alongside it is cleared. Our own
     markup is the single source of truth for that price: the buy box already
     states the saving, in its own styling, directly under the selection it
     belongs to. */
  function topPriceElement() {
    var element = document.querySelector('[data-pickie-top-price]');

    if (!element) {
      var wrapper = document.querySelector('[data-price-wrapper]');
      if (!wrapper) return null;

      /* Whatever the app left behind is still the price slot; reclaim it. */
      element =
        wrapper.querySelector('[data-product-price]') ||
        wrapper.querySelector('.pickie-top-price-wrap') ||
        wrapper.firstElementChild;

      if (!element) return null;
      element.setAttribute('data-pickie-top-price', '');
    }

    /* Apstle also writes `text-decoration: line-through` inline onto this
       element and everything inside it, which struck the price the customer
       actually pays. pickie-pdp.css overrides that with `!important` (the only
       thing that beats an inline style), and this clears the property so the
       DOM itself is honest rather than merely overridden — the two together
       mean neither a re-render nor a stylesheet change can bring it back. */
    var struck = [element].concat(
      Array.prototype.slice.call(element.querySelectorAll('[style*="line-through"]'))
    );
    struck.forEach(function (node) {
      if (node.style && node.style.textDecoration) {
        if (node.classList && node.classList.contains('pickie-top-compare-price')) return;
        node.style.removeProperty('text-decoration');
        node.style.removeProperty('text-decoration-line');
      }
    });

    /* Drop app-injected siblings so they cannot accumulate. Only inside the
       price wrapper, and only nodes that are not ours. */
    var host = element.closest('[data-price-wrapper]');
    if (host) {
      Array.prototype.forEach.call(
        host.querySelectorAll('.appstle-save-badge, [data-appstle-price-modified]'),
        function (node) {
          if (node === element) {
            node.removeAttribute('data-appstle-price-modified');
            return;
          }
          if (element.contains(node) || node.contains(element)) {
            node.removeAttribute('data-appstle-price-modified');
            return;
          }
          node.remove();
        }
      );

      /* More than one price slot in the wrapper means something duplicated
         it; keep ours and remove the rest. Snapshotted first: `host.children`
         is a LIVE collection, so removing while iterating it skips nodes. */
      Array.prototype.slice.call(host.children).forEach(function (child) {
        if (child !== element && !child.contains(element) && !element.contains(child)) {
          child.remove();
        }
      });
    }

    return element;
  }

  function updateTopPrice(root, currentCents, compareCents, isSubscribe) {
    var priceElement = topPriceElement();
    if (!priceElement) return;

    var current = money(root, currentCents);
    var compare = money(root, compareCents);

    if (isSubscribe && currentCents < compareCents) {
      priceElement.innerHTML =
        '<span class="pickie-top-price-wrap">' +
          '<span class="pickie-top-compare-price">' + compare + '</span>' +
          '<span class="pickie-top-current-price">' + current + '</span>' +
        '</span>';
    } else {
      priceElement.innerHTML =
        '<span class="pickie-top-price-wrap">' +
          '<span class="pickie-top-current-price">' + current + '</span>' +
        '</span>';
    }
  }

  function updatePackCards(root, isSubscribe) {
    var freeShippingCents = toNumber(root.getAttribute('data-free-shipping-cents'));

    Array.prototype.forEach.call(root.querySelectorAll('[data-pickie-r3-pack]'), function (card) {
      var oneTimeCents = toNumber(card.getAttribute('data-onetime-cents'));
      var subscribeCents = toNumber(card.getAttribute('data-subscribe-cents'), oneTimeCents);
      var packCount = Math.max(1, toNumber(card.getAttribute('data-pack-count'), 1));
      var currentCents = isSubscribe ? subscribeCents : oneTimeCents;
      var price = card.querySelector('[data-pickie-r3-pack-price]');
      var compare = card.querySelector('[data-pickie-r3-pack-compare]');
      var unit = card.querySelector('[data-pickie-r3-unit-price]');
      var shipping = card.querySelector('[data-pickie-r3-pack-shipping]');

      if (price) price.textContent = money(root, currentCents);
      if (unit) unit.textContent = money(root, currentCents / packCount) + '/bottle';

      if (compare) {
        compare.textContent = money(root, oneTimeCents);
        compare.hidden = !(isSubscribe && subscribeCents < oneTimeCents);
      }

      if (shipping) {
        shipping.hidden = !(freeShippingCents > 0 && currentCents >= freeShippingCents);
      }
    });
  }

  function updateSubscriptionCard(root, pack) {
    var subscribeCard = root.querySelector('[data-pickie-r3-purchase="subscribe"]');
    if (!subscribeCard || !pack) return;

    var planId = pack.getAttribute('data-selling-plan-id');
    var savingsPercent = toNumber(pack.getAttribute('data-savings-percent'));
    var badge = subscribeCard.querySelector('[data-pickie-r3-save-badge]');
    var copy = subscribeCard.querySelector('[data-pickie-r3-subscribe-copy]');
    var input = subscribeCard.querySelector('input[type="radio"]');
    var canSubscribe = Boolean(planId);

    subscribeCard.classList.toggle('is-disabled', !canSubscribe);
    subscribeCard.setAttribute('aria-disabled', canSubscribe ? 'false' : 'true');
    if (input) input.disabled = !canSubscribe;

    if (badge) {
      badge.textContent = savingsPercent > 0 ? 'Save ' + savingsPercent + '%' : 'Subscribe';
    }

    if (copy) {
      /* The tile is dimmed and its radio disabled when the pack has no selling
         plan, but the copy used to still read "Automatic deliveries. Pause or
         cancel anytime." — describing something the customer cannot actually
         choose, so a tap that did nothing had no explanation. The 24- and
         36-packs are in exactly this state today: no Apstle group yet. */
      if (!canSubscribe) {
        copy.textContent = 'Not available on this pack size yet.';
      } else if (savingsPercent > 0) {
        copy.textContent = 'Save ' + savingsPercent + '% on every order. Pause or cancel anytime.';
      } else {
        copy.textContent = 'Automatic deliveries. Pause or cancel anytime.';
      }
    }
  }

  function render(root) {
    var form = root.closest('form');
    var pack = activePack(root);
    var purchase = activePurchase(root);
    if (!form || !pack || !purchase) return;

    /* Apstle re-injects its plan radios asynchronously after a variant change,
       so they are re-disabled on every render and once more after its own
       re-render has had time to land. */
    neutraliseForeignPlanFields(form);
    window.setTimeout(function () { neutraliseForeignPlanFields(form); }, 300);

    var isSubscribe = purchase.getAttribute('data-pickie-r3-purchase') === 'subscribe';
    var oneTimeCents = toNumber(pack.getAttribute('data-onetime-cents'));
    var subscribeCents = toNumber(pack.getAttribute('data-subscribe-cents'), oneTimeCents);
    var currentCents = isSubscribe ? subscribeCents : oneTimeCents;
    var packCount = Math.max(1, toNumber(pack.getAttribute('data-pack-count'), 1));
    var savingsPercent = toNumber(pack.getAttribute('data-savings-percent'));
    var savingsPerCase = Math.max(0, oneTimeCents - subscribeCents);
    var qty = quantity(form);
    var totalCents = currentCents * qty;
    var freeShippingCents = toNumber(root.getAttribute('data-free-shipping-cents'));
    var summaryTitle = root.querySelector('[data-pickie-r3-summary-title]');
    var summaryDetail = root.querySelector('[data-pickie-r3-summary-detail]');
    var summaryTotal = root.querySelector('[data-pickie-r3-summary-total]');
    var savings = root.querySelector('[data-pickie-r3-savings]');
    var savingsCopy = root.querySelector('[data-pickie-r3-savings-copy]');
    var totalBottles = packCount * qty;
    var shippingMessage = 'Ships as ' + (qty === 1 ? 'one case' : qty + ' cases');

    updatePackCards(root, isSubscribe);
    updateSubscriptionCard(root, pack);

    if (freeShippingCents > 0) {
      if (totalCents >= freeShippingCents) {
        shippingMessage = 'Free shipping unlocked';
      } else {
        shippingMessage = 'Add ' + money(root, freeShippingCents - totalCents) + ' for free shipping';
      }
    }

    if (summaryTitle) {
      summaryTitle.textContent = totalBottles + ' bottles · ' +
        (isSubscribe ? 'Subscribe & save' : 'One-time purchase');
    }

    if (summaryDetail) {
      summaryDetail.textContent = money(root, currentCents / packCount) + '/bottle · ' + shippingMessage;
    }

    if (summaryTotal) summaryTotal.textContent = money(root, totalCents);

    if (savings && savingsCopy) {
      if (isSubscribe && savingsPerCase > 0) {
        savings.hidden = false;
        savingsCopy.textContent = 'You save ' + money(root, savingsPerCase * qty) +
          ' (' + savingsPercent + '%) today—and on every delivery.';
      } else {
        savings.hidden = true;
        savingsCopy.textContent = '';
      }
    }

    updateTopPrice(root, currentCents, oneTimeCents, isSubscribe);
  }

  /* The repeated 40/220/420ms re-renders existed to win races against the
     legacy buy box and the hardening layer, both of which are gone. A single
     synchronous render is now correct and removes three layout passes per tap. */

  function selectPack(root, card) {
    var form = root.closest('form');
    if (!form || !card) return;

    activate(root, '[data-pickie-r3-pack]', card);
    setVariant(form, card.getAttribute('data-variant-id'));

    var purchase = activePurchase(root);
    var subscribing = purchase && purchase.getAttribute('data-pickie-r3-purchase') === 'subscribe';
    var planId = card.getAttribute('data-selling-plan-id');

    /* If this pack has no selling plan (e.g. a new pack size whose Apstle group
       has not been created yet), fall back to one-time rather than posting a
       subscription the variant cannot fulfil. */
    if (subscribing && !planId) {
      var oneTime = root.querySelector('[data-pickie-r3-purchase="onetime"]');
      if (oneTime) activate(root, '[data-pickie-r3-purchase]', oneTime);
      subscribing = false;
    }

    setSellingPlan(form, subscribing ? planId : '');
    render(root);
  }

  function selectPurchase(root, card) {
    var form = root.closest('form');
    var pack = activePack(root);
    if (!form || !pack || !card) return;

    var purchaseType = card.getAttribute('data-pickie-r3-purchase');
    var planId = pack.getAttribute('data-selling-plan-id');

    if (purchaseType === 'subscribe' && !planId) return;

    activate(root, '[data-pickie-r3-purchase]', card);
    setSellingPlan(form, purchaseType === 'subscribe' ? planId : '');
    render(root);
  }

  function bind(root) {
    if (root.getAttribute('data-pickie-r3-ready') === 'true') return;

    var form = root.closest('form');
    if (!form) return;

    root.setAttribute('data-pickie-r3-ready', 'true');
    moveQuantityIntoBuybox(root, form);

    Array.prototype.forEach.call(root.querySelectorAll('[data-pickie-r3-pack] input'), function (input) {
      input.addEventListener('change', function () {
        if (input.checked) selectPack(root, input.closest('[data-pickie-r3-pack]'));
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-pickie-r3-purchase] input'), function (input) {
      input.addEventListener('change', function () {
        if (input.checked) selectPurchase(root, input.closest('[data-pickie-r3-purchase]'));
      });
    });

    form.addEventListener('input', function (event) {
      if (event.target && event.target.matches('input[name="quantity"]')) render(root);
    });

    form.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[name="quantity"]')) render(root);
    });

    form.addEventListener('click', function (event) {
      if (event.target.closest('[data-quantity-plus], [data-quantity-minus], [data-quantity-button]')) {
        window.setTimeout(function () { render(root); }, 30);
      }
    });

    var currentVariantId = root.getAttribute('data-current-variant-id');
    var initialPack = root.querySelector('[data-pickie-r3-pack][data-variant-id="' + currentVariantId + '"]') ||
      activePack(root);
    var requestedPlan = new URLSearchParams(window.location.search).get('selling_plan');

    selectPack(root, initialPack);

    if (requestedPlan && initialPack && requestedPlan === initialPack.getAttribute('data-selling-plan-id')) {
      selectPurchase(root, root.querySelector('[data-pickie-r3-purchase="subscribe"]'));
    } else {
      selectPurchase(root, root.querySelector('[data-pickie-r3-purchase="onetime"]'));
    }

    render(root);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
